import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const fargateOption: Option<CriteriaKey> = {
  name: 'AWS Fargate',
  description:
    'A compute engine that allows you to run containers without having to manage servers or clusters.',
  tags: ['Serverless', 'Containers'],
  pros: ['Scalable', 'Cost-effective', 'Simple', 'Secure'],
  cons: ['Operational Management'],
  documentationLink: 'https://aws.amazon.com/fargate/',
  criteriaScores: {
    asyncExecution: { score: { value: 3 } },
    scalability: { score: { value: 10 } },
    unlimitedExecutionTimeout: { score: { value: 10 } },
    storagePersistance: { score: { value: 1 } },
    vendorLockIn: { score: { value: 1 } },
    containerizationLimitations: { score: { value: 1 } },
    operationalManagement: { score: { value: 3 } },
    etlOriented: { score: { value: 1 } },
    batchingProcessing: { score: { value: 1 } },
  },
};
